var f="#ffffff";export{f as default};
